import { getDefaultTablePagination } from '@/modules/pipeline/stores/board/PipelineBoard.normalizers';
import type { PipelineBoardCacheEntry } from '@/modules/pipeline/types/Pipeline.types';
import type {
  PipelineBoardTableRowView,
  PipelineBoardTableState,
  PipelineKanbanColumnView,
} from '@/modules/pipeline/types/Pipeline.types';
import { buildPipelineKanbanColumnViews } from '@/modules/pipeline/utils/PipelinePresentation.utils';

export const selectBoardColumns = (
  entry: PipelineBoardCacheEntry | null | undefined,
): Array<PipelineKanbanColumnView> => {
  if (!entry) {
    return [];
  }

  return buildPipelineKanbanColumnViews(entry.columns);
};

export const selectTableState = (
  entry: PipelineBoardCacheEntry | null | undefined,
): PipelineBoardTableState | null => {
  return entry?.tableState ?? null;
};

export const selectTableRows = (
  entry: PipelineBoardCacheEntry | null | undefined,
): Array<PipelineBoardTableRowView> => {
  return entry?.tableState.rows ?? [];
};

export const selectTablePagination = (
  entry: PipelineBoardCacheEntry | null | undefined,
) => {
  return entry?.tableState.pagination ?? getDefaultTablePagination();
};

export const selectIsTableLoading = (
  entry: PipelineBoardCacheEntry | null | undefined,
): boolean => {
  return entry?.tableState.isLoading ?? false;
};

export const selectStageIds = (
  entry: PipelineBoardCacheEntry | null | undefined,
): string[] => {
  return entry?.stageIds ?? [];
};
